import { toBool } from '../formatters';

export const EBAY_RAG_PROMPT_MARKER = 'Additional context (retrieved from eBay image search):';
export const EBAY_RAG_PROMPT_SUFFIX_PREVIEW =
  'Additional context (retrieved from eBay image search):\n' +
  '[{"title":"example title","price":"0","currency":"USD","condition":"example condition","itemWebUrl":"https://example.com","itemId":"example-id"}]\n' +
  'Use this only as supporting market context. Prioritize visual evidence in the uploaded images and do not copy titles blindly if they do not match.';
export const NOTES_RAG_PROMPT_MARKER =
  'Additional context (few-shot examples from reviewed test-rig notes):';
export const NOTES_RAG_PROMPT_SUFFIX_PREVIEW =
  'Additional context (few-shot examples from reviewed test-rig notes):\n' +
  '[{"lot_number":"123","dataset_prefix":"Auction 18","lot_note":"Short reviewer note for the lot.","ai_estimated_total":245.5,"actual_total":210.0,"lot_accuracy":0.856,"lot_duration_ms":2180.0,"lot_cost":0.0241,"lot_cache_hit":false,"ai_items":[{"item":"Example item","estimated_value":145.5,"actual_price":120.0,"accuracy":0.825,"condition":"Used","price_source":"model_knowledge"}],"subitem_notes":[{"item":"Example item","estimated_value":145.5,"actual_price":120.0,"accuracy":0.825,"condition":"Used","price_source":"model_knowledge","review_note":"Short reviewer note for this subitem."}],"example_image_refs":["test-rig-items/dataset/lot123/img1.jpg","test-rig-items/dataset/lot123/img2.jpg"],"reference_image_metadata":[{"image_ref":"test-rig-items/dataset/lot123/img1.jpg","image_order":1,"lot_number":"123","dataset_prefix":"Auction 18","run_id":"run-abc","subitem_note_count":1,"has_lot_note":true}],"example_image_count":2}]\n' +
  'Treat these as reviewer-authored few-shot examples from prior runs. Use them as guidance when similar patterns appear, but prioritize the uploaded images and do not copy notes blindly. Use existing reviewer notes only as context; never invent, populate, or return item/subitem note fields in detected_items output.';
export const HIDDEN_ITEMS_PROMPT_MARKER = 'Hidden-item inference mode:';
export const HIDDEN_ITEMS_PROMPT_ON_SUFFIX =
  'Hidden-item inference mode: ON\n' +
  'When items are packed in boxes, pallets, bins, or behind other objects, infer likely hidden/occluded units from visible packaging and context, and include those estimated hidden units as separate entries.';
export const HIDDEN_ITEMS_PROMPT_OFF_SUFFIX =
  'Hidden-item inference mode: OFF\n' +
  'OVERRIDE: Ignore hidden-item assumptions. Only return items that are clearly visible in the uploaded images. Do not estimate, infer, or add hidden/occluded/background items.';

const RUNTIME_PROMPT_MARKERS = [
  HIDDEN_ITEMS_PROMPT_MARKER,
  EBAY_RAG_PROMPT_MARKER,
  NOTES_RAG_PROMPT_MARKER,
];

export const stripEbayRagPromptBlock = (promptTemplate) => {
  const text = String(promptTemplate || '');
  const markerIndexes = RUNTIME_PROMPT_MARKERS.map((marker) => text.indexOf(marker)).filter(
    (idx) => idx >= 0,
  );
  if (markerIndexes.length === 0) return text.trim();
  return text.slice(0, Math.min(...markerIndexes)).trim();
};

export const withRagPromptPreview = (
  promptTemplate,
  ebayEnabled,
  notesEnabled,
  assumeHiddenItems = null,
) => {
  const base = stripEbayRagPromptBlock(promptTemplate);
  const promptText = String(promptTemplate || '');
  const inferredHiddenItems = promptText.includes('Hidden-item inference mode: OFF')
    ? false
    : promptText.includes('Hidden-item inference mode: ON')
      ? true
      : true;
  const hiddenEnabled =
    assumeHiddenItems === null || assumeHiddenItems === undefined
      ? inferredHiddenItems
      : toBool(assumeHiddenItems, true);
  const previewBlocks = [];
  previewBlocks.push(hiddenEnabled ? HIDDEN_ITEMS_PROMPT_ON_SUFFIX : HIDDEN_ITEMS_PROMPT_OFF_SUFFIX);
  if (toBool(ebayEnabled, false)) {
    previewBlocks.push(EBAY_RAG_PROMPT_SUFFIX_PREVIEW);
  }
  if (toBool(notesEnabled, false)) {
    previewBlocks.push(NOTES_RAG_PROMPT_SUFFIX_PREVIEW);
  }
  if (!base && previewBlocks.length === 0) return '';
  if (!base) return previewBlocks.join('\n\n');
  if (previewBlocks.length === 0) return base;
  return `${base}\n\n${previewBlocks.join('\n\n')}`;
};

export const withEbayRagPromptPreview = (promptTemplate, ragEnabled) =>
  withRagPromptPreview(promptTemplate, ragEnabled, false);
